<template>
    <v-alert
		:value="true"
		:color="notification.type"
		outline
		class="notification"
		style="padding: 10px 20px 10px 20px; background-color: #FFF;"
	>
	<div style="display:flex; padding-left:20px">
		<v-badge v-if="count > 1"
			:color="notification.type"
			>
			<template v-slot:badge>
				{{ count }}
			</template>
		</v-badge>
		<div style="display:flex; align-items: center; white-space: pre-line;">{{ notification.message }}</div>
		<v-spacer />
		<v-btn
			icon
			depressed
			@click="remove()"
		>
			<v-icon color="rgba(255, 255, 255, 0.5)"
			>close</v-icon>
		</v-btn>
	</div>
	</v-alert>
</template>
<script>
export default {
	name: 'Notification',
	props: [
		'notification',
	],
	data() {
		return {
			activeTimeout: -1,
		};
	},
	mounted() {
		this.setTimeout();
	},
	methods: {
		setTimeout() {
			window.clearTimeout(this.activeTimeout);
			const { timeout } = this.notification.state;
			if (timeout) {
				this.activeTimeout = window.setTimeout(() => {
					this.remove();
				}, timeout);
			}
		},
		remove() {
			this.$emit('remove');
		},
	},
	computed: {
		count() {
			return this.notification.state.count;
		},
	},
}
</script>
<style>
	.v-badge__badge{
		right:0px;
		top: 50%;
		transform: translate(-50%,-50%);
	}
	.notification .v-btn{
		color:#999 !important;
	}
	.notification {
		margin: 0;
	}

</style>
